import {DOWNLOAD_USERS, GET_SEARCH_USERS, GET_USER, GET_USERS, UPDATE_USER} from "../actions/user";

export default function(state = {}, action) {
  switch (action.type) {
      case GET_USERS:
        return { ...state, ...action.payload };
      case GET_USER:
        return { ...state, ...action.payload };
      case UPDATE_USER:
        return { ...state, ...action.payload };
      case DOWNLOAD_USERS:
        return { ...state, ...action.payload };
      case GET_SEARCH_USERS:
        return { ...state, ...action.payload.results };
      default:
        return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/user.js